export { EcoLabel } from './EcoLabel';
